export const LINE_STYLE = [
  {
    dashStyle: 'Solid',
    lineWidth: 3,
  },
  {
    dashStyle: 'LongDash',
    lineWidth: 2,
  },
  {
    dashStyle: 'Dot',
    lineWidth: 2,
  },
];



// WEBPACK FOOTER //
// ./src/features/home/components/constants/CompareChartConstants.js